<template>
  <v-btn @click="createEditSplitConfiguration" color="primary" target="_blank" elevation="0">
    <v-icon left> mdi-plus </v-icon>
    <span class="d-none d-md-flex body-2">
      {{ $t('split.action.create') }}
    </span>
  </v-btn>
</template>


<script>
import { mapActions } from 'vuex'

export default {
  name: 'SplitHeaderActions',

  methods: {
    ...mapActions(['handleOpenCreateEditSplitConfigurationModal']),

    createEditSplitConfiguration() {
      this.handleOpenCreateEditSplitConfigurationModal()

      const createSplitConfiguration = this.$parent?.$parent?.$refs.rentOutRouterView?.$refs.createSplitConfiguration
      this.$nextTick(() => createSplitConfiguration.resetForm())
    }
  }
}
</script>
